import { SESSION_KEY } from "../constants";

export const saveSession = (user) => { try { localStorage.setItem(SESSION_KEY, JSON.stringify(user)); } catch {} };
export const loadSession = () => { try { const s=localStorage.getItem(SESSION_KEY); return s?JSON.parse(s):null; } catch { return null; } };
export const clearSession = () => { try { localStorage.removeItem(SESSION_KEY); } catch {} };
